import * as THREE from 'three';

export default class ObjectHTML {

  constructor() {
    this.position = new THREE.Vector3(0, 0, 0);
    this.domElement = document.createElement('div');
    this.dirStart = null;
    this.dirEnd = null;
    this.optimalCameraDist = null; // the distance at which the scale of the object is 1
    this.zoomFactor = 1; // the rate at which scale changes
    this.allowRotation = true;
    this.allowScaling = true;
    this.transformOrigin = '';  
  }

  render(camera, renderer) {
    var rendererSize = new THREE.Vector2();
    renderer.getSize(rendererSize);

    let scale;
    if (this.optimalCameraDist) {
      let dist = Math.sqrt(
        Math.pow(camera.position.x - this.position.x, 2) + 
        Math.pow(camera.position.y - this.position.y, 2) + 
        Math.pow(camera.position.z - this.position.z, 2)
      );
      // contain the scale between [0.6, 1]
      scale = Math.min(1, Math.max(0.6, (this.optimalCameraDist / (dist * camera.zoom)) * this.zoomFactor));
    } else {
      // VladP: Set a minimum multiplier to prevent very small objects
      scale = Math.max(0.75, camera.zoom);
    }
    
    const pos = this.position.clone();
    // if (this.applyDynamicPadding)
    //   this.applyDynamicPadding(pos, camera, renderer);
    pos.project(camera);

    const widthHalf = rendererSize.x / 2;
    const heightHalf = rendererSize.y / 2;

    pos.x = (pos.x * widthHalf) + widthHalf;
    pos.y = -(pos.y * heightHalf) + heightHalf;


    let rotationCSS = "";
    if (this.allowRotation && this.dirStart && this.dirEnd) {
      // var viewMatrix = new THREE.Matrix4();
      // var viewProjectionMatrix = new THREE.Matrix4();
      // viewMatrix.copy(camera.matrixWorldInverse);
      // viewProjectionMatrix.multiplyMatrices(camera.projectionMatrix, viewMatrix);
      
      var projStart = this.dirStart.clone();
      // projStart.applyMatrix4(viewProjectionMatrix);
      projStart.project(camera);
      projStart.x = Math.round((projStart.x + 1) * rendererSize.x / 2);
      projStart.y = Math.round((-projStart.y + 1) * rendererSize.y / 2);
      //projStart.x = (projStart.x * widthHalf) + widthHalf;
      //projStart.y = -(projStart.y * heightHalf) + heightHalf;
      var projEnd = this.dirEnd.clone();
      // projEnd.applyMatrix4(viewProjectionMatrix);
      projEnd.project(camera);
      projEnd.x = Math.round((projEnd.x + 1) * rendererSize.x / 2);
      projEnd.y = Math.round((-projEnd.y + 1) * rendererSize.y / 2);
      //projEnd.x = (projEnd.x * widthHalf) + widthHalf;
      //projEnd.y = -(projEnd.y * heightHalf) + heightHalf;
      
      var cameraDir = new THREE.Vector3();
      camera.getWorldDirection(cameraDir);
      //var dir = new THREE.Vector3().subVectors(this.dirEnd, this.dirStart).normalize();
      //var projDir = dir.dot(cameraDir) < 0 ?  // angle greater than 90 degrees => opposite directions
      //  new THREE.Vector3().subVectors(projStart, projEnd).normalize() :
      //  new THREE.Vector3().subVectors(projEnd, projStart).normalize(); 
      var dir = new THREE.Vector3().subVectors(projEnd, projStart).normalize();
      let degrees = dir.angleTo(new THREE.Vector3(1, 0, 0)) * 180 / Math.PI;

      // cameraDir.z = -cameraDir.z;
      //let degrees = projDir.angleTo(new THREE.Vector3(1, 0, 0)) * 180 / Math.PI;
      // let degrees = (new THREE.Vector2(projDir.x, projDir.y)).angle() * 180 / Math.PI;
      if (this.isTextPerpendicular)
        degrees = 90 - degrees;
       if (degrees > 90) // switch the side of the text
         degrees = -180 + degrees;

      // invert rotation if the text direction and camera direction are opposite or if the camera looks from above?
      let invert = (cameraDir.y > 0 !== dir.y > 0);
      if ((invert || cameraDir.y < 0) && (invert !== cameraDir.y < 0))
        degrees = -degrees;
      // let invert = cameraDir.dot(camera.up) < 0 ? dir.dot(cameraDir) >= 0 : dir.dot(cameraDir) < 0;
      //let invert = dir.dot(cameraDir) < 0; // angle greater than 90 degrees => opposite directions

      // invert works only for normal orientation? .. must find a formula to work on all orientations!!!

      // var crossDir = new THREE.Vector3().crossVectors(cameraDir, dir).normalize();
      // let invert = false;
      // if (crossDir.dot(camera.up) < 0)
      //   invert = dir.dot(cameraDir) >= 0;
      // else 
      //   invert = dir.dot(cameraDir) < 0;
      // let invert = crossDir.dot(camera.up) < 0 ? dir.dot(cameraDir) >= 0 : dir.dot(cameraDir) < 0;
      // if (invert)
      //   degrees = -degrees;

      if (Math.abs(degrees) > 1e-2) {
        rotationCSS = "rotate(" + degrees + "deg) ";
        this.rotationDegrees = degrees;
      } else if (!this.transformOrigin) {
        this.transformOrigin = "50% 50%";
      }
    }

    this.domElement.style.left = `${pos.x}px`;
    this.domElement.style.top = `${pos.y}px`;
    this.domElement.style.transform = rotationCSS + (this.allowScaling ? `scale(${scale}, ${scale})` : '');
    if (this.transformOrigin)
      this.domElement.style.transformOrigin = this.transformOrigin;
    else 
      this.domElement.style.transformOrigin = rotationCSS && !this.isTextPerpendicular ? "50% 50%" : "0% 0%";
  }

  getElementRect() {
    return this.domElement.getBoundingClientRect();
  }

  setDirection(start, end, isTextPerpendicular = false) {
    if (start && end) {
      this.dirStart = new THREE.Vector3(start.x, start.y, start.z);
      this.dirEnd = new THREE.Vector3(end.x, end.y, end.z);
      this.isTextPerpendicular = isTextPerpendicular;
    }
  }

}



// WEBPACK FOOTER //
// ./src/object-view/misc/html/html.object.js